<template>
  <div>
    <label :for="'pricetier_' + pricetier.id">{{ pricetier.name }}</label>
    <select class="form-control" :name="'pricetier_' + pricetier.id" v-model="count" v-on:change="select">
      <option :value="0">0</option>
      <option v-for="loop in 1000" :value="loop">{{ loop }}</option>
    </select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selectedCount: null
    }
  },
  computed: {
    count: {
      get () {
        if (this.selectedCount) {
          return this.selectedCount
        }
        return this.value
      },
      set (newValue) {
        this.selectedCount = newValue
      }
    }
  },
  methods: {
    select () {
      this.$emit('input', this.selectedCount)
    }
  },
  props: ['value', 'pricetier']
}
</script>